import apiService from '../apiService';

export const getShopSettings = () => apiService.GET('/api/admin/shop-settings');
export const updateShopSettings = (data) =>
    apiService.PUT('/api/admin/shop-settings', data);

export const getConsentProfiles = (params = {}) =>
    apiService.GET('/api/admin/consent-profiles', params);
export const getConsentProfileOptions = () =>
    apiService.GET('/api/admin/consent-profiles/options');
export const getConsentProfile = (id) =>
    apiService.GET(`/api/admin/consent-profiles/${id}`);
export const createConsentProfile = (data) =>
    apiService.POST('/api/admin/consent-profiles', data);
export const updateConsentProfile = (id, data) =>
    apiService.PUT(`/api/admin/consent-profiles/${id}`, data);
export const deleteConsentProfile = (id) =>
    apiService.DELETE(`/api/admin/consent-profiles/${id}`);

export const getContractTemplates = (params = {}) =>
    apiService.GET('/api/admin/contract-templates', params);
export const getContractTemplateOptions = () =>
    apiService.GET('/api/admin/contract-templates/options');
export const getContractTemplateDefaults = () =>
    apiService.GET('/api/admin/contract-templates/defaults');
export const compileContractTemplate = (data) =>
    apiService.POST('/api/admin/contract-templates/compile', data);
export const previewContractTemplate = (data) =>
    apiService.POST('/api/admin/contract-templates/preview', data);
export const getContractTemplate = (id) =>
    apiService.GET(`/api/admin/contract-templates/${id}`);
export const createContractTemplate = (data) =>
    apiService.POST('/api/admin/contract-templates', data);
export const updateContractTemplate = (id, data) =>
    apiService.PUT(`/api/admin/contract-templates/${id}`, data);
export const deleteContractTemplate = (id) =>
    apiService.DELETE(`/api/admin/contract-templates/${id}`);
